import React from 'react';

import { Box, Divider, Paragraph, StackView, Typography } from '@telus-uds/components-web';

import { ContentWrapper } from '../design/css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Expired = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contractSignature: {
      expiredPage: { header, message }
    }
  } = localizedStrings;

  return (
    <>
      <StackView space={4}>
        <Divider />
        <Divider />
      </StackView>
      <div className="container 85%">
        <ContentWrapper>
          <StackView space={3}>
            <Typography heading="h2" variant={{ size: 'h2' }} block>{header}</Typography>
          </StackView>
          <Paragraph>
            <Typography variant={{ bold: true }}>{message}</Typography>
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Expired;
